import clsx from 'clsx';

import { DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import { useNavigation } from '../../../navigation';
import { apiClient } from '../../../state';
import { ImportContentDialog } from '../../Imports';
import { FileIllustration } from '../../Onboarding/cards/FileIllustration';
import { QuickActionCard, QuickActionCardHeading } from '../../Onboarding/cards/QuickActionCard';
import type { SpaceCreationOnCreateSpace } from './types';

interface ImportCardProps {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function ImportCard(props: ImportCardProps) {
    const { organizationId, onCreateSpace } = props;
    const { navigate } = useNavigation();
    return (
        <DialogRoot>
            <DialogTrigger>
                <QuickActionCard>
                    <div className="relative flex gap-2">
                        <FileIllustration
                            color="#3193D4"
                            text=".MD"
                            className={clsx(
                                'translate-x-[25px] transition-transform ease-snappy-out',
                                'group-hover/card:translate-y-[1px] group-hover/card:-rotate-12 group-focus/card:translate-y-[1px] group-focus/card:-rotate-12',
                                'group-hover/card:translate-x-[18px] group-focus/card:translate-x-[18px]',
                                'group-hover/card:scale-[1.03] group-focus/card:scale-[1.03]'
                            )}
                        />
                        <FileIllustration
                            color="#289a70"
                            text="CSV"
                            className={clsx(
                                'transition-transform ease-snappy-out group-hover/card:scale-[1.05] group-focus/card:scale-[1.05]'
                            )}
                        />
                        <FileIllustration
                            color="#F72F35"
                            text="HTML"
                            className={clsx(
                                '-translate-x-[25px] transition-transform ease-snappy-out',
                                'group-hover/card:-translate-x-[18px] group-hover/card:translate-y-[1px] group-hover/card:rotate-12 group-focus/card:-translate-x-[18px] group-focus/card:translate-y-[1px] group-focus/card:rotate-12',
                                'group-hover/card:scale-[1.03] group-focus/card:scale-[1.03]'
                            )}
                        />
                    </div>
                    <QuickActionCardHeading>Import</QuickActionCardHeading>
                </QuickActionCard>
            </DialogTrigger>
            <ImportContentDialog
                trigger="space_creation"
                target={{ organization: organizationId }}
                onStart={(target) => {
                    onCreateSpace(
                        async ({ collectionId }) => {
                            if (collectionId !== target.space.parent) {
                                const result = await apiClient.spaces.moveSpace(target.space.id, {
                                    parent: collectionId,
                                });
                                return result.data;
                            }
                            return target.space;
                        },
                        (space) => {
                            navigate({
                                screen: {
                                    type: 'space',
                                    space: space.id,
                                    organization: space.organization,
                                    page: '',
                                    changeRequest: target.changeRequestId,
                                },
                            });
                        }
                    );
                }}
            />
        </DialogRoot>
    );
}
